// eslint-disable-next-line
export function isFalsy(value: any): value is boolean {
  return !value
}
